import createSvgIcon from '../Utils/CreateSvgIcon';

export const ViewColumns = createSvgIcon(
  <path d="M160.23-304.62v-350.76q0-26.66 18.98-45.64T224.85-720h510.53q26.66 0 45.64 18.98T800-655.38v350.76q0 26.66-18.98 45.64T735.38-240H224.85q-26.66 0-45.64-18.98t-18.98-45.64ZM224.62-280h135.3v-400h-135.3q-9.24 0-16.93 7.69-7.69 7.69-7.69 16.93v350.76q0 9.24 7.69 16.93 7.69 7.69 16.93 7.69Zm175.3 0h159.93v-400H399.92v400Zm199.93 0h135.3q9.23 0 16.93-7.69 7.69-7.69 7.69-16.93v-350.76q0-9.24-7.69-16.93-7.7-7.69-16.93-7.69h-135.3v400Z" />,
  'ViewColumns',
  '0 -960 960 960',
);
